import {viewsApi} from '@dv5/api'
import {ErrorDisplayProcessor} from '@dv5/components'
import {DvDocument, useAppDispatch} from '@dv5/domain'
import {FC, useEffect, useState} from 'react'
import {createPortal} from 'react-dom'
import './DocumentPicker.less'

interface Props {
    onSelect: (document: DvDocument) => void
    onCancel: () => void
}

export const DocumentPicker: FC<Props> = ({onSelect, onCancel}) => {
    const dispatch = useAppDispatch()
    const [documents, setDocuments] = useState<DvDocument[]>([])
    const [filter, setFilter] = useState('')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        let active = true
        viewsApi.loadDocuments(new ErrorDisplayProcessor(dispatch), items => {
            if (active) {
                setDocuments(items)
                setLoading(false)
            }
        }).then(success => {
            if (active && !success) { setError(true); setLoading(false) }
        }).catch(() => {
            if (active) { setError(true); setLoading(false) }
        })
        return () => { active = false }
    }, [dispatch])

    const visible = documents.filter(item => item.title.toLocaleLowerCase().includes(filter.toLocaleLowerCase()))
    return createPortal(
        <div className="document-picker-overlay" onMouseDown={e => e.stopPropagation()} onMouseUp={e => e.stopPropagation()} onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
            <div className="document-picker" role="dialog" aria-modal="true" aria-label="Choose document">
                <h3>Choose document</h3>
                <input autoFocus aria-label="Filter documents by title" placeholder="Filter by title" value={filter} onChange={e => setFilter(e.target.value)} onKeyDown={e => { if (e.key === 'Escape') onCancel() }}/>
                <div className="document-picker-list">
                    {loading && <p>Loading documents…</p>}
                    {error && <p>Could not load documents.</p>}
                    {!loading && !error && visible.length === 0 && <p>{documents.length ? 'No matching documents.' : 'No documents available.'}</p>}
                    {visible.map(item => <button type="button" key={item.id} onClick={() => onSelect(item)}>{item.title}</button>)}
                </div>
                <button type="button" onClick={onCancel}>Cancel</button>
            </div>
        </div>
    , document.body)
}
